/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */

import javaSnippet from './templates/code/kafka-java.hbs';
import consoleConsumerSnippet from './templates/code/kafka-console-consumer.hbs';
import kafkaJSSnippet from './templates/code/kafka-js.hbs';
import noderdKafkaSnippet from './templates/code/kafka-noderd.hbs';
import kafkaPythonSnippet from './templates/code/kafka-python.hbs';
import kafkacatSnippet from './templates/code/kafka-kafkacat.hbs';

import javaDependencies from './templates/dependencies/kafka-java.hbs';
import kafkaJSDependencies from './templates/dependencies/kafka-js.hbs';
import noderdKafkaDependencies from './templates/dependencies/kafka-noderd.hbs';
import kafkaPythonDependencies from './templates/dependencies/kafka-python.hbs';

import { codeLanguages } from './constants';

const renderSnippet = (codeLanguage, options) => {
  switch (codeLanguage) {
    case codeLanguages.java: {
      return { snippet: javaSnippet(options), dependencies: javaDependencies(options) };
    }
    case codeLanguages.consoleConsumer: {
      return { snippet: consoleConsumerSnippet(options) };
    }
    case codeLanguages.kafkaJS: {
      return { snippet: kafkaJSSnippet(options), dependencies: kafkaJSDependencies(options) };
    }
    case codeLanguages.noderdKafka: {
      return { snippet: noderdKafkaSnippet(options), dependencies: noderdKafkaDependencies(options) };
    }
    case codeLanguages.kafkaPython: {
      return { snippet: kafkaPythonSnippet(options), dependencies: kafkaPythonDependencies(options) };
    }
    case codeLanguages.kafkacat: {
      return { snippet: kafkacatSnippet(options) };
    }
    default: {
      throw new Error(`Snippets for ${codeLanguage} are not supported`);
    }
  }
};

// eslint-disable-next-line import/prefer-default-export
export { renderSnippet };
